import React from "react";
import { resources } from "../Home/components/Resources";
import Header from "../../components/Header";
import { getImageFromAssetFolder } from "../../utils/assets";
import Footer from "../Home/components/Footer";

const Resources = () => {
  const heroArticle = {
    title: "Why I Built ZeroEqualOne!",
    description:
      "ZeroEqualOne is built on my journey from a small village to becoming a self-taught engineer. Our mission is simple: give students clarity, confidence, and smarter ways to learn — turning effort into real impact.",
    src: "/resources/why-i-built-zeroequalone",
  };

  return (
    <>
      <Header />
      <div className="flex flex-col min-h-screen px-4 sm:px-8">
        {/* Hero Section */}
        <section
          className="px-4 sm:px-12 py-8 sm:py-12 rounded-xl flex flex-col items-center w-full"
          style={{ background: "#f2f8fd" }}
        >
          <div className="max-w-5xl mx-auto flex flex-col text-center sm:text-left">
            <div className="flex flex-col justify-center">
              <h2
                className="text-2xl font-bold leading-tight mb-2 
                           bg-gradient-to-r from-blue-900 to-pink-500 
                           bg-clip-text text-transparent"
              >
                Founder's Story
              </h2>
              <h1 className="text-4xl font-bold leading-tight mb-2">
                {heroArticle.title}
              </h1>
              <p className="text-sm sm:text-base text-gray-700 mb-6">
                {heroArticle.description}
              </p>
              <a
                href={heroArticle.src}
                className="hover:opacity-90 transition w-[120px]"
              >
                <button className="btn py-2 w-[100%] text-sm sm:text-base bg-gradient-to-r from-blue-900 to-pink-700">
                  Read Now
                </button>
              </a>
            </div>
          </div>
        </section>

        {/* Articles Section */}
        <section className="flex-1 py-6 sm:py-8">
          <div className="max-w-5xl mx-auto">
            <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3">
              {resources.map((article) => (
                <div
                  key={article.slug}
                  className="bg-[#f2f8fd] p-6 rounded-2xl shadow-sm hover:shadow-md transition"
                >
                  <h3 className="text-xl font-semibold mb-3">
                    {article.title}
                  </h3>
                  <p className="text-gray-600 mb-4">{article.description}</p>
                  <a
                    href={`/resources/${article.slug}`}
                    className="text-blue-600 font-medium hover:underline"
                  >
                    Read More →
                  </a>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default Resources;
